const VIMEO_URL_REGEX = /(?:http:\/\/)?(?:www\.)?(?:vimeo\.com)\/(.+)/g;
const TWITTER_URL_REGEX = /(?:https?:\/\/)?(?:(?:twitter\.com)|(?:x\.com))\/(.*)(\/status)\/(.+)/g;
const SPOTIFY_URL_REGEX = /^(?:https?:\/\/)?(?:play|open)\.spotify\.com\/(track|album|playlist|artist|show|episode)\/(.+)|https?:\/\/embed.spotify.com\/\?uri=spotify:(track|album|playlist|artist|show|episode):(.+)$/;

export { SPOTIFY_URL_REGEX, TWITTER_URL_REGEX, VIMEO_URL_REGEX };
//# sourceMappingURL=regex.js.map
